interface Props {
  label?: string;
  fullScreen?: boolean;
}

export default function LoadingSpinner({ label = "Loading...", fullScreen = true }: Props) {
  return (
    <div
      className={
        fullScreen
          ? "h-full flex flex-col items-center justify-center gap-3 bg-background font-sans"
          : "flex flex-col items-center justify-center gap-3 py-12 font-sans"
      }
    >
      <div className="w-7 h-7 rounded-full border-[3px] border-border border-t-primary animate-[spin_0.8s_linear_infinite]" />
      {label ? <p className="text-muted-foreground text-sm m-0">{label}</p> : null}
    </div>
  );
}
